import styled from 'styled-components'
import { HeadlineWrap } from '../nlp/NlpContainer.style'

export const UsersContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-right: 40px;
`

export const UsersHeadlineWrap = styled.div(HeadlineWrap)

export const UserSearchWrap = styled.div`
  width: 400px;
`

export const UsersFilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const UsersControlLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 34px;
`

export const UsersButtonWrap = styled.div`
  & button {
    text-transform: unset;
  }

  & button:first-child {
    margin-right: 10px;
  }

  & button svg path {
    stroke: var(--color-text-on-primary);
  }
`

/* CareBrain (master) primary CTA label. */
export const ButtonTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-on-primary);
`

/* QCS primary CTA label — sentence case, body-strong. */
export const ButtonTitleQcs = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0;
  text-transform: none;
  white-space: nowrap;
  color: var(--color-text-on-primary);
`
